export default "__VITE_ASSET__972fce6c__"